import QueryClientProvider from '@tmh-website/components/containers/QueryClientProvider';
import { LocalePrefix } from '@tmh-website/shared/const';
import { theme as baseTheme } from '@tmh-website/styles/theme';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { StyleSheetManager, ThemeProvider } from 'styled-components';
import App from './app/app';
import './global.scss';

const theme = {
  ...baseTheme,
  fontFamily: {
    headlines: 'Sculpin',
    body: 'Inter',
  },
  headerHeight: baseTheme.headerHeightCombined,
};

// Hide audiences in cart
const isCartPage =
  window && Object.values(LocalePrefix).find(locale => window.location.pathname.startsWith(`/${locale}/checkout/cart`));
if (isCartPage) {
  theme.headerHeight = baseTheme.headerHeight;
}

const host = document.getElementById('tmh-website-header') as HTMLElement;
const shadowRoot = host.attachShadow({ mode: 'open' });

const renderRoot = document.createElement('div');
renderRoot.id = 'render-root';
shadowRoot.appendChild(renderRoot);

const root = createRoot(renderRoot);
root.render(
  <StrictMode>
    <StyleSheetManager target={shadowRoot as unknown as HTMLElement}>
      <QueryClientProvider>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </QueryClientProvider>
    </StyleSheetManager>
  </StrictMode>
);
